import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory, useLocation } from "react-router-dom";
import usePeerTalk from "../hooks/usePeerTalk";
import { CommentIcon, EyeIcon, ShareIcon } from "../../../../components/svgs";
import {
  BackButton,
  DynamicButton,
  StyledText,
} from "../../../../components/common";
import { useTheme } from "../../../../hooks";
import CommentCard from "../components/commentCard";
import LoadingUI from "../components/LoadingUI";
import InappropriateCommentModal from "../components/InappropriateCommentModal";

const TopicDetails = () => {
  const { themeContext, theme } = useTheme();
  const background = theme.colors[themeContext.activeTheme]["background"];
  const history = useHistory();
  const location = useLocation();
  const [inputComment, setInputComment] = useState("");
  const [story, setStory] = useState({});
  const { data } = location.state || {};

  const {
    loading,
    error,
    submitComment,
    userDetails,
    getCommentsByStoryId,
    getStory,
    activeStory,
    comments,
    processingComment,
    isInappropriateCommentModalVisible,
    closeInapproprateModal,
  } = usePeerTalk();

  useEffect(() => {
    getCommentsByStoryId(data._id);
    getStory(data._id);
  }, []);

  useEffect(() => {
    if (activeStory?.numberOfComments || activeStory?.numberOfViews) {
      setStory(activeStory);
    }
  }, [activeStory, activeStory?.numberOfComments, activeStory?.numberOfViews]);

  useEffect(() => {
    if (data) {
      setStory(data);
    }
  }, [data]);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    try {
      await submitComment(data._id, userDetails.msisdn, inputComment);
      setInputComment("");
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };

  const handleShare = () => {
    const shareData = {
      title: "PeerTalk!",
      text: story.title,
      url: `${window.location.href}`, // story._id - we need to get the id of the story
    };

    if (navigator.share) {
      navigator
        .share(shareData)
        .then(() => console.log("Shared successfully"))
        .catch((error) => console.error("Error sharing:", error));
    } else {
      // Fallback for devices/browsers that don't support Web Share API
      navigator.clipboard.writeText(shareData.url);
      alert("Link copied to clipboard");
    }
  };

  if (loading) return <LoadingUI />;
  if (error) return <p>Error: {error}</p>;

  return (
    <>
      {isInappropriateCommentModalVisible && (
        <InappropriateCommentModal onBackDropClick={closeInapproprateModal} />
      )}
      <div
        style={{
          position: "absolute",
          zIndex: 100,
          width: "100%",
          minHeight: "100%",
          top: "250px",
          paddingBottom: "20px",
          backgroundColor: "#fff",
        }}
      >
        <div
          style={{
            boxSizing: "border-box",
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "white",
          }}
        >
          <BackButton onClick={() => history.goBack()} />
          <Wrapper>
            <Image src={data.image} />
            <Gradient>
              <CardDetails>
                <Body>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      backgroundColor: "transparent",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <div style={{ fontSize: "24px", paddingBottom: "4px" }}>
                      {data.icon}
                    </div>
                    <StyledText
                      size={18}
                      color={"white"}
                      style={{
                        width: "90%",
                        margin: 0,
                        fontFamily: "MTNRegular",
                      }}
                    >
                      {data.category}
                    </StyledText>
                  </div>
                  <StyledText
                    style={{ margin: "0 0 5px 0", width: "100%" }}
                    size={16}
                    color={"white"}
                  >
                    {story.title}
                  </StyledText>
                </Body>
              </CardDetails>
            </Gradient>
            <div
              style={{
                backgroundColor: data.color,
                width: "100%",
                height: 40,
                display: "flex",
                alignItems: "center",
              }}
            >
              <IconsWrapper>
                <IconsContainer>
                  <EyeIcon isVisible fill={"white"} width={36} height={36} />
                  <StyledText
                    size={16}
                    color={"white"}
                    style={{
                      width: "90%",
                      marginLeft: 5,
                      fontFamily: "MTNRegular",
                    }}
                  >
                    {story.numberOfViews}
                  </StyledText>
                </IconsContainer>
                <IconsContainer>
                  <CommentIcon width={36} />
                  <StyledText
                    size={16}
                    color={"white"}
                    style={{
                      width: "90%",
                      marginLeft: 5,
                      fontFamily: "MTNRegular",
                    }}
                  >
                    {story.numberOfComments}
                  </StyledText>
                </IconsContainer>
                <ShareIconContainer>
                  <ShareIcon />
                </ShareIconContainer>
              </IconsWrapper>
            </div>
          </Wrapper>
          <ContentWrapper>
            <MessageContainer>
              <StyledText
                size={15}
                style={{ fontFamily: "MTNRegular", whiteSpace: "pre-wrap" }}
              >
                {story.message}
              </StyledText>
            </MessageContainer>
            <HorizontalSeparator />
            {/* Render the CommentCard with the current comments */}
            <CommentCard
              comments={(comments && comments[data?._id]) || []}
              storyColor={data.color}
            />
            <CommentSection>
              <StyledText>Leave a reply</StyledText>
              <CommentInputForm onSubmit={handleSubmit}>
                <textarea
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    height: 70,
                    padding: "10px",
                    fontFamily: "MTNRegular",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                  }}
                  placeholder="Add your voice to the conversation..."
                  type="text"
                  value={inputComment}
                  onChange={(e) => setInputComment(e.target.value)}
                />
                <div style={{ width: "100%", marginTop: "15px" }}>
                  <DynamicButton
                    disabled={processingComment}
                    color={"rgb(247,206,70)"}
                    textColor={"#000"}
                    fullWidth
                    onClick={handleSubmit}
                    label={processingComment ? "Processing..." : "Post Comment"}
                  />
                </div>
              </CommentInputForm>
            </CommentSection>
          </ContentWrapper>
        </div>
      </div>
    </>
  );
};

export default TopicDetails;

const Wrapper = styled.div`
  width: 100%;
  height: 230px;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
`;

const Image = styled.img`
  width: 100%;
  height: 230px;
  object-fit: cover;
  position: absolute;
`;
const Gradient = styled.div`
  width: 100%;
  height: 230px;

  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.17) 39.58%,
    #000000 100%
  );
  position: relative;
  z-index: 1;
  display: grid;
  grid-auto-flow: column;
  align-items: flex-end;
`;

const Body = styled.div`
  box-sizing: border-box;
  padding: 10px 20px 10px 20px;
`;

const CommentInputForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

const CardDetails = styled.div``;
const IconsWrapper = styled.div`
  display: flex;
  width: 100%;
`;
const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  padding-inline: 20px;
  padding-right: 0;
`;

const ShareIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  padding-right: 20px;
  width: 60%;
`;

const MessageContainer = styled.div`
  padding-top: 10%;
`;
const CommentSection = styled.div``;
const ContentWrapper = styled.div`
  padding-inline: 25px;
`;
const HorizontalSeparator = styled.div`
  height: 1px;
  width: 100%;
  background-color: #d9d9d9;
  margin-top: 10px;
  margin-bottom: 10px;
`;
